import { MessageType } from '@/config/enum';
import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';

@Module({ namespaced: true, name: 'message', store, dynamic: true })
class MessageModule extends VuexModule {
  public message: string | null = null;
  public type: MessageType | null = null;

  @MutationAction
  public async showMessage(data: { message: string; type: MessageType }) {
    return { message: data.message, type: data.type };
  }

  @MutationAction
  public async setMessage(message: string | null) {
    return { message: message };
  }
}

const messageModule = getModule(MessageModule);
export default messageModule;
